// extracted by mini-css-extract-plugin
export default {"field":"NewOrganizationForm_field__wqULz","submitButton":"NewOrganizationForm_submitButton__Ysdn-"};